export default "__VITE_ASSET__CGSaedkL__"